// extracted by mini-css-extract-plugin
module.exports = {"tinyLoader":"_2wF0KvG0CeZbyNbgiRle8u","load3":"EcHyjPjs_SB-IpNOIJg6t"};